import { Component } from '@angular/core';
import { AbstractFieldDirective } from '../abstract-field.directive';
import { toNumberValue, toTextValue } from '../../tool/field.function';

@Component({
  selector: 'app-long-text-field',
  templateUrl: './long-text-field.component.html',
  styleUrls: ['./long-text-field.component.scss']
})
export class LongTextFieldComponent extends AbstractFieldDirective {

  protected get value(): string {
    return this.field?.value ?? '';
  }

  protected get minLength(): undefined | number {
    if (!this.field?.minValue)
      return undefined;
    return Number(this.field.minValue);
  }
  protected get maxLength(): undefined | number {
    if (!this.field?.maxValue)
      return undefined;
    return Number(this.field.maxValue);
  }

  protected updateValue(value?: null | string): void {
    if (!this.field)
      return;
    const newValue = toTextValue(value);
    if (this.field.value === newValue)
      return;
    this.field.value = newValue;
    this.fieldChange.emit(this.field);
  }

  protected updateMinLength(length?: null | number): void {
    if (!this.field)
      return;
    const minValue = toNumberValue(length);
    if (this.field.minValue === minValue)
      return;
    this.field.minValue = minValue;
    this.fieldChange.emit(this.field);
  }
  protected updateMaxLength(length?: null | number): void {
    if (!this.field)
      return;
    const maxValue = toNumberValue(length);
    if (this.field.maxValue === maxValue)
      return;
    this.field.maxValue = maxValue;
    this.fieldChange.emit(this.field);
  }

  protected get error(): string {
    if (this.value === undefined)
      return '';
    if (!this.value && !this.required)
      return '';
    if (this.minLength !== undefined && this.value.length < this.minLength)
      return `Le nombre de caractères doit être supérieur ou égal à ${this.minLength}.`;
    if (this.maxLength !== undefined && this.value.length > this.maxLength)
      return `Le nombre de caractères doit être inférieur ou égal à ${this.maxLength}.`;
    return '';
  }

}
